export const countryData =
    [
        {
            name: "中国",
            code: "cn"
        },
        {
            name: "日本",
            code: "jp"
        },
        {
            name: "美国",
            code: "us"
        },
        {
            name: "韩国",
            code: "kr"
        },
        {
            name: "世界知识产权组织",
            code: "wo"
        },
        {
            name: "德国",
            code: "de"
        },
        {
            name: "英国",
            code: "gb"
        },
        {
            name: "法国",
            code: "fr"
        },
        {
            name: "加拿大",
            code: "ca"
        },
        {
            name: "中国台湾",
            code: "tw"
        },
        {
            name: "澳大利亚",
            code: "au"
        },
        {
            name: "西班牙",
            code: "es"
        },
        {
            name: "俄罗斯",
            code: "ru"
        },
        {
            name: "前苏联",
            code: "zn"
        },
        {
            name: "奥地利",
            code: "at"
        },
        {
            name: "意大利",
            code: "it"
        },
        {
            name: "印度",
            code: "in"
        },
        {
            name: "巴西",
            code: "br"
        },
        {
            name: "欧盟",
            code: "eu"
        },
        {
            name: "瑞典",
            code: "se"
        },
        {
            name: "挪威",
            code: "no"
        },
        {
            name: "瑞士",
            code: "ch"
        },
        {
            name: "芬兰",
            code: "fi"
        },
        {
            name: "丹麦",
            code: "dk"
        },
        {
            name: "波兰",
            code: "pl"
        },
        {
            name: "墨西哥",
            code: "mx"
        },
        {
            name: "荷兰",
            code: "nl"
        },
        {
            name: "比利时",
            code: "be"
        },
        {
            name: "以色列",
            code: "il"
        },
        {
            name: "中国香港",
            code: "hk"
        },
        {
            name: "南非",
            code: "za"
        },
        {
            name: "马来西亚",
            code: "my"
        },
        {
            name: "匈牙利",
            code: "hu"
        },
        {
            name: "葡萄牙",
            code: "pt"
        },
        {
            name: "阿根廷",
            code: "ar"
        },
        {
            name: "乌克兰",
            code: "ua"
        },
        {
            name: "捷克",
            code: "cz"
        },
        {
            name: "印度尼西亚",
            code: "id"
        },
        {
            name: "新西兰",
            code: "nz"
        },
        {
            name: "新加坡",
            code: "sg"
        },
        {
            name: "希腊",
            code: "gr"
        },
        {
            name: "罗马尼亚",
            code: "ro"
        },
        {
            name: "欧亚专利组织",
            code: "ea"
        },
        {
            name: "爱尔兰",
            code: "ie"
        },
        {
            name: "土耳其",
            code: "tr"
        },
        {
            name: "智利",
            code: "cl"
        },
        {
            name: "南斯拉夫",
            code: "sh"
        },
        {
            name: "越南",
            code: "vn"
        },
        {
            name: "菲律宾",
            code: "ph"
        },
        {
            name: "塞拉利昂共和国",
            code: "si"
        },
        {
            name: "秘鲁",
            code: "pe"
        },
        {
            name: "保加利亚",
            code: "bg"
        },
        {
            name: "克罗地亚",
            code: "hr"
        },
        {
            name: "斯洛伐克",
            code: "sk"
        },
        {
            name: "哥伦比亚",
            code: "co"
        },
        {
            name: "卢森堡",
            code: "lu"
        },
        {
            name: "非洲区域知识产权组织",
            code: "ap"
        },
        {
            name: "乌拉圭",
            code: "uy"
        },
        {
            name: "塞浦路斯",
            code: "cy"
        },
        {
            name: "塞尔维亚",
            code: "rs"
        },
        {
            name: "摩尔多瓦共和国",
            code: "md"
        },
        {
            name: "泰国",
            code: "th"
        },
        {
            name: "突尼斯",
            code: "tn"
        },
        {
            name: "厄瓜多尔",
            code: "ec"
        },
        {
            name: "立陶宛",
            code: "lt"
        },
        {
            name: "埃及",
            code: "eg"
        },
        {
            name: "非洲知识产权组织",
            code: "oa"
        },
        {
            name: "摩洛哥",
            code: "ma"
        },
        {
            name: "蒙古",
            code: "mn"
        },
        {
            name: "中国澳门",
            code: "mo"
        },
        {
            name: "哥斯达黎加",
            code: "cr"
        },
        {
            name: "拉脱维亚",
            code: "lv"
        },
        {
            name: "爱沙尼亚",
            code: "ee"
        },
        {
            name: "危地马拉",
            code: "gt"
        },
        {
            name: "冰岛",
            code: "is"
        },
        {
            name: "古巴",
            code: "cu"
        },
        {
            name: "摩纳哥",
            code: "mc"
        },
        {
            name: "格鲁吉亚",
            code: "ge"
        },
        {
            name: "多米尼加",
            code: "do"
        },
        {
            name: "约旦",
            code: "jo"
        },
        {
            name: "巴拿马",
            code: "pa"
        },
        {
            name: "沙特阿拉伯",
            code: "sa"
        },
        {
            name: "海湾地区阿拉伯国家合作委员会专利局",
            code: "gc"
        },
        {
            name: "圣马力诺",
            code: "sm"
        },
        {
            name: "黑山",
            code: "me"
        },
        {
            name: "萨尔瓦多",
            code: "sv"
        },
        {
            name: "尼加拉瓜",
            code: "ni"
        },
        {
            name: "津巴布韦",
            code: "zw"
        },
        {
            name: "洪都拉斯",
            code: "hn"
        },
        {
            name: "文莱",
            code: "bn"
        },
        {
            name: "赞比亚",
            code: "zm"
        },
        {
            name: "阿尔及利亚",
            code: "dz"
        },
        {
            name: "马耳他",
            code: "mt"
        },
        {
            name: "巴林",
            code: "bh"
        },
        {
            name: "巴拉圭",
            code: "py"
        },
        {
            name: "肯尼亚",
            code: "ke"
        },
        {
            name: "马拉维",
            code: "mw"
        },
        {
            name: "委内瑞拉",
            code: "ve"
        },
        {
            name: "塔吉克斯坦",
            code: "tj"
        },
        {
            name: "阿拉伯联合酋长国",
            code: "ae"
        },
        {
            name: "玻利维亚",
            code: "bo"
        },
        {
            name: "波斯尼亚和黑塞哥维那",
            code: "ba"
        },
        {
            name: "哈萨克斯坦",
            code: "kz"
        },
        {
            name: "孟加拉国",
            code: "bd"
        },
        {
            name: "伊拉克共和国",
            code: "iq"
        },
        {
            name: "白俄罗斯",
            code: "by"
        },
        {
            name: "老挝",
            code: "la"
        },
        {
            name: "柬埔寨",
            code: "kh"
        },
        {
            name: "叙利亚",
            code: "sy"
        },
        {
            name: "乌兹别克斯坦",
            code: "uz"
        },
        {
            name: "阿塞拜疆",
            code: "az"
        },
        {
            name: "马其顿共和国",
            code: "mk"
        },
        {
            name: "土库曼斯坦",
            code: "tm"
        },
        {
            name: "亚美尼亚",
            code: "am"
        },
        {
            name: "吉尔吉斯斯坦",
            code: "kg"
        },
        {
            name: "多巴哥",
            code: "tt"
        }
    ]
